<template>
  <el-container>
    <!-- 左侧树形菜单 -->
    <el-aside width="12%" style="background-color: #f5f7fa; border-right: 1px solid #e6e6e6; height: 100%; overflow-y: auto;">
      <div class="logo-container">
        <div class="logo">
          <i class="el-icon-s-platform"></i>
        </div>
        <div class="system-name">码上放心</div>
      </div>
      
      <el-tree
        :data="treeData"
        :props="defaultProps"
        node-key="id"
        default-expand-all
        highlight-current
        @node-click="handleNodeClick"
        ref="tree"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <i :class="data.icon" v-if="data.icon"></i>
          <span>{{ node.label }}</span>
        </span>
      </el-tree>
    </el-aside>
    
    <!-- 右侧主内容区域 -->
    <el-container>
      <el-header style="height: 8%; padding: 0; background-color: #fff; border-bottom: 1px solid #e6e6e6;">
        <div class="header-content">
          <div class="page-title">{{ currentPageTitle }}</div>
          
          <div class="filter-section">
            <div class="filter-item">
              <span class="filter-label">状态：</span>
              <el-select v-model="queryParams.uploadStatus" placeholder="请选择" size="small" style="width: 120px;">
                <el-option label="待上传" :value="0"></el-option>
                <el-option label="成功" :value="1"></el-option>
                <el-option label="失败" :value="2"></el-option>
                <el-option label="处理中" :value="3"></el-option>
              </el-select>
            </div>
            
            <div class="filter-item">
              <el-input
                v-model="queryParams.billCode"
                placeholder="单据编号"
                size="small"
                style="width: 150px;"
                clearable
              ></el-input>
            </div>
            
            <div class="filter-item">
              <el-date-picker
                v-model="dateRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                style="width: 300px;"
              ></el-date-picker>
            </div>
            
            <el-button type="primary" size="small" icon="el-icon-Ssearch" @click="handleSearch">查询</el-button>
          </div>
        </div>
      </el-header>
      
      <el-main>
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          stripe
          size="small"
        >
          <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
          <el-table-column prop="billCode" label="上传单据号" width="120" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="bizNum" label="业务单据编号" width="120" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="bizType" label="业务类型" width="100" align="center" :formatter="formatBizType"></el-table-column>
          <el-table-column prop="billTime" label="单据业务时间" width="140" align="center"></el-table-column>
          <el-table-column prop="traceCodeCount" label="追溯码数量" width="100" align="center"></el-table-column>
          <el-table-column prop="uploadStatus" label="上传状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag
                :type="getUploadStatusTagType(scope.row.uploadStatus)"
                size="small"
                :icon="getUploadStatusIcon(scope.row.uploadStatus)"
              >
                {{ getUploadStatusText(scope.row.uploadStatus) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="lastUploadTime" label="最后上传时间" width="140" align="center"></el-table-column>
          <el-table-column prop="msgInfo" label="返回信息" min-width="150" show-overflow-tooltip></el-table-column>
          
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <!-- 成功状态显示详情按钮 -->
              <el-button 
                v-if="scope.row.uploadStatus === 1"
                size="mini" 
                type="primary" 
                icon="el-icon-document" 
                @click="handleDetail(scope.row)"
                title="详情"
              >详情</el-button>
              <!-- 失败状态显示补传按钮 -->
              <el-button 
                v-else-if="scope.row.uploadStatus === 2"
                size="mini" 
                type="warning" 
                icon="el-icon-refresh" 
                @click="openTransferDialog(scope.row)"
                title="补传"
              >补传</el-button>
              <!-- 其他状态不显示按钮 -->
              <span v-else></span>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.pageNum"
            :page-sizes="[5, 8, 10, 20]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
        
        <div class="action-buttons">
          <el-button type="primary" size="small" disabled>默认查询</el-button>
          <el-button type="success" size="small" disabled>追溯码补录</el-button>
        </div>
      </el-main>
    </el-container>

    <!-- 追溯码补传穿梭框模态框 -->
    <el-dialog
      :title="transferDialogTitle"
      :visible.sync="transferDialogVisible"
      width="900px"
      class="trace-code-transfer-dialog"
    >
      <!-- 自定义header，使用渐变色背景 -->
      <template slot="title">
        <div class="custom-dialog-header">
          <span class="dialog-title-text">{{ transferDialogTitle }}</span>
        </div>
      </template>
      
      <div class="transfer-dialog-content">
        <!-- 穿梭框组件 -->
        <el-transfer
          v-model="selectedTraceCodes"
          :data="traceCodesData"
          :titles="['所有追溯码', '已选中追溯码']"
          :button-texts="['移除', '添加']"
          :format="{
            noChecked: '${total}',
            hasChecked: '${checked}/${total}'
          }"
          filterable
          :filter-method="filterMethod"
          filter-placeholder="请输入追溯码搜索"
          style="text-align: left; display: inline-block; width: 100%;"
        >
          <!-- 左侧列表插槽 -->
          <span slot-scope="{ option }" class="trace-code-item">
            <span :class="{'error-trace-code': option.isError}">
              {{ option.label }}
              <el-tag
                v-if="option.isError"
                size="mini"
                type="danger"
                style="margin-left: 5px;"
              >
                错误
              </el-tag>
            </span>
          </span>
          
          <!-- 底部按钮 -->
          <div slot="right-footer" style="padding: 10px; text-align: center; border-top: 1px solid #ebeef5;">
            <el-button
              type="warning"
              icon="el-icon-refresh"
              @click="startRetryUpload"
              :disabled="selectedTraceCodes.length === 0"
              style="width: 100%; margin-bottom: 10px;"
            >
              补传
            </el-button>
            <el-button
              @click="closeTransferDialog"
              style="width: 100%;"
            >
              关闭
            </el-button>
          </div>
        </el-transfer>
        
        <!-- 错误明细展示区域 -->
        <div class="error-details" v-if="operationErrorCodes.length > 0">
          <div class="error-title">
            <i class="el-icon-warning" style="color: #e6a23c; margin-right: 5px;"></i>
            错误明细中的追溯码：
          </div>
          <div class="error-codes">
            <el-tag
              v-for="code in operationErrorCodes"
              :key="code"
              type="danger"
              size="small"
              style="margin-right: 5px; margin-bottom: 5px;"
            >
              {{ code }}
            </el-tag>
          </div>
        </div>
        
        <!-- 底部关闭按钮 -->
        <div class="dialog-footer" style="margin-top: 20px; text-align: center;">
          <el-button @click="closeTransferDialog">关闭</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 步骤进度条模态框 -->
    <el-dialog
      title="追溯码补传进度"
      :visible.sync="retryUploadDialog"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="trace-code-upload-dialog"
    >
      <div class="upload-progress-dialog">
        <!-- 步骤条 -->
        <el-steps 
          :active="retryUploadStep" 
          align-center
          finish-status="success"
          class="upload-steps"
        >
          <el-step
            v-for="(step, index) in retryUploadSteps"
            :key="index"
            :title="step.title"
            :description="step.description"
            :status="getStepStatus(index)"
          ></el-step>
        </el-steps>
        
        <!-- 进度详情 -->
        <div class="upload-details">
          <div class="details-title">上传详情：</div>
          <div 
            class="details-content" 
            ref="uploadDetailsContainer"
            style="max-height: 200px; overflow-y: auto;"
          >
            <div 
              v-for="(detail, index) in retryUploadDetails" 
              :key="index"
              class="detail-item"
              :class="detail.type"
            >
              <i :class="getDetailIcon(detail.type)"></i>
              <span>{{ detail.message }}</span>
              <span class="detail-time">{{ detail.time }}</span>
            </div>
          </div>
        </div>
        
        <!-- 进度条 -->
        <div v-if="retryUploadStep < retryUploadSteps.length" class="upload-progress">
          <el-progress
            :percentage="retryUploadProgress"
            :status="retryUploadStatus"
            :show-text="false"
          ></el-progress>
        </div>
      </div>
      
      <!-- 进度条模态框的footer部分 -->
      <template slot="footer" class="upload-dialog-footer">
        <!-- 失败时显示"我已知晓"按钮 -->
        <div v-if="showRetryButton && retryUploadHasError">
          <el-button
            @click="closeRetryUploadDialog"
            type="primary"
          >
            我已知晓
          </el-button>
        </div>
        
        <!-- 正常完成时自动关闭，不显示按钮 -->
        <div v-else-if="retryUploadStep === 5 && !retryUploadHasError && retryUploadSuccess">
          <!-- 自动关闭，不显示按钮 -->
        </div>
        
        <!-- 上传失败但补传成功，需要显示"我已知晓"按钮 -->
        <div v-else-if="retryUploadStep === 5 && !retryUploadHasError && !retryUploadSuccess">
          <el-button
            @click="closeRetryUploadDialog"
            type="primary"
          >
            我已知晓
          </el-button>
        </div>
        
        <!-- 未完成时显示取消按钮 -->
        <div v-else>
          <el-button
            @click="handleRetryUploadCancel"
          >
            取消
          </el-button>
        </div>
      </template>
    </el-dialog>
  </el-container>
</template>

<script>
import { traceCodeUploadRecord } from "@/api/msfx"
// 新增引入接口
import { 
  msfxCodeDetail, 
  msfxGetEntInfoList, 
  msfListUpoutDetail, 
  msfxUploadInoutBill, 
  msfxUploadRetail,
  getSomeWare,  // 新增：根据药品名称和包装数量检索接口
  getCJSomeWare  // 新增：根据批准文号和药品ID获取厂家信息接口
} from "@/api/systemCatalogue/Western.js";

export default {
  name: 'Msfx',
  data() {
    return {
      // 左侧树形数据
      treeData: [
        {
          id: 1,
          label: '码上放心/追溯码',
          icon: 'el-icon-s-platform',
          children: [
            { id: 11, label: '采购入库', icon: 'el-icon-s-goods' },
            { id: 12, label: '采购出库', icon: 'el-icon-s-order' },
            { id: 13, label: '追溯码统计', icon: 'el-icon-s-data' }
          ]
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // 当前选中的节点
      currentNode: null,
      currentPageTitle: '码上放心/追溯码',
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 8,
        billCode: '',
        bizNum: '',
        bizType: '',
        startTime: '',
        endTime: '',
        uploadStatus: ''
      },
      dateRange: [],
      // 表格数据
      tableData: [],
      total: 0,
      
      // 穿梭框模态框相关
      transferDialogVisible: false,
      transferDialogTitle: '',
      traceCodesData: [],
      selectedTraceCodes: [],
      operationErrorCodes: [],
      currentRetryRow: null,
      
      // 补传进度条相关
      retryUploadDialog: false,
      retryUploadStep: 0,
      retryUploadSteps: [
        { title: '检查数据', description: '正在检查补传数据...' },
        { title: '准备补传', description: '正在准备补传参数...' },
        { title: '调用接口', description: '正在调用补传接口...' },
        { title: '上传结果', description: '正在处理上传结果...' },
        { title: '完成补传', description: '补传完成。' }
      ],
      retryUploadDetails: [],
      retryUploadHasError: false,
      showRetryButton: false,
      retryUploadSuccess: true,
      retryUploadError: '',
      retryUploading: false,
      autoCloseTimer: null
    };
  },
  computed: {
    retryUploadProgress() {
      const totalSteps = this.retryUploadSteps.length;
      return Math.floor((this.retryUploadStep / totalSteps) * 100);
    },
    retryUploadStatus() {
      if (this.retryUploadHasError) return 'exception';
      return 'success';
    }
  },
  mounted() {
    // 默认加载第一个节点的数据
    this.fetchData();
  },
  methods: {
    // 树节点点击事件
    handleNodeClick(data, node) {
      this.currentNode = data;
      if (node.level === 2) {
        this.currentPageTitle = `码上放心/追溯码 / ${data.label}`;
        // 重置查询参数
        this.queryParams = {
          pageNum: 1,
          pageSize: 8,
          billCode: '',
          bizNum: '',
          bizType: '',
          startTime: '',
          endTime: '',
          uploadStatus: ''
        };
        this.dateRange = [];
        // 重新加载数据
        this.fetchData();
      }
    },
    // 查询数据
    fetchData() {
      // 设置日期范围
      if (this.dateRange && this.dateRange.length === 2) {
        this.queryParams.startTime = this.dateRange[0].toISOString();
        this.queryParams.endTime = this.dateRange[1].toISOString();
      } else {
        this.queryParams.startTime = '';
        this.queryParams.endTime = '';
      }
      
      // 调用接口获取数据
      traceCodeUploadRecord(this.queryParams)
        .then(res => {
          console.log('接口返回数据:', res);
          if (res.data && res.data.content) {
            this.tableData = res.data.content;
            this.total = res.data.totalElements || 0;
          } else {
            this.tableData = [];
            this.total = 0;
            console.error('接口返回数据格式不正确:', res);
          }
        })
        .catch(err => {
          console.error('Error fetching data:', err);
          this.tableData = [];
          this.total = 0;
        });
    },
    // 查询按钮点击事件
    handleSearch() {
      this.queryParams.pageNum = 1; // 重置到第一页
      this.fetchData();
    },
    // 格式化业务类型
    formatBizType(row) {
      const bizTypeMap = {
        102: '采购入库',
        111: '盘盈入库',
		214: '盘亏入库',
		113: '其他入库',
        103: '退药/退货入库',
        // 201: '销售出库',
        217: '其他出库',
        202: '采购退库', // 新增
        321: '销售出库'  // 新增
      };
      return bizTypeMap[row.bizType] || row.bizType;
    },
    // 上传状态相关方法
    getUploadStatusTagType(status) {
      switch (parseInt(status)) {
        case 0: return 'primary';  // 待上传
        case 1: return 'success';  // 成功
        case 2: return 'danger';   // 失败
        case 3: return 'warning';  // 处理中
        default: return 'info';
      }
    },
    getUploadStatusIcon(status) {
      switch (parseInt(status)) {
        case 0: return 'el-icon-s-order';  // 待上传
        case 1: return 'el-icon-success';  // 成功
        case 2: return 'el-icon-error';    // 失败
        case 3: return 'el-icon-loading';  // 处理中
        default: return 'el-icon-question';
      }
    },
    getUploadStatusText(status) {
      switch (parseInt(status)) {
        case 0: return '待上传';
        case 1: return '成功';
        case 2: return '失败';
        case 3: return '处理中';
        default: return '未知';
      }
    },
    // 详情按钮点击事件
    handleDetail(row) {
      console.log('查看详情:', row);
      this.$message.info(`查看详情: ${row.billCode || row.bizNum}`);
    },
    // 打开穿梭框模态框
    openTransferDialog(row) {
      this.currentRetryRow = row;
      this.transferDialogTitle = `${row.bizNum} - 单据详情`;
      
      // 解析追溯码列表
      const traceCodes = row.traceCodes ? row.traceCodes.split(',').map(code => code.trim()).filter(code => code) : [];
      
      // 解析错误明细中的追溯码
      this.operationErrorCodes = this.parseErrorTraceCodes(row.operationInfo);
      
      // 构建穿梭框数据
      this.traceCodesData = traceCodes.map(code => {
        const isError = this.operationErrorCodes.includes(code);
        return {
          key: code,
          label: code,
          disabled: isError, // 错误的追溯码禁用
          isError: isError
        };
      });
      
      // 默认选中错误的追溯码
      this.selectedTraceCodes = this.operationErrorCodes.filter(code => traceCodes.includes(code));
      
      this.transferDialogVisible = true;
    },
    // 关闭穿梭框模态框
    closeTransferDialog() {
      this.transferDialogVisible = false;
      this.selectedTraceCodes = [];
      this.traceCodesData = [];
      this.operationErrorCodes = [];
      this.currentRetryRow = null;
    },
    // 解析错误明细中的追溯码
    parseErrorTraceCodes(operationInfo) {
      if (!operationInfo) return [];
      
      // 尝试多种方式解析错误明细中的追溯码
      const errorCodes = [];
      
      // 1. 查找包含追溯码格式的字符串
      const traceCodeRegex = /[A-Z0-9]{10,30}/g;
      const matches = operationInfo.match(traceCodeRegex);
      if (matches) {
        errorCodes.push(...matches);
      }
      
      // 2. 查找以逗号分隔的追溯码
      const commaCodes = operationInfo.split(',')
        .map(code => code.trim())
        .filter(code => code && code.length >= 10);
      
      if (commaCodes.length > 0) {
        errorCodes.push(...commaCodes);
      }
      
      // 去重
      return [...new Set(errorCodes)];
    },
    // 穿梭框搜索方法
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    // 开始补传
    startRetryUpload() {
      if (this.selectedTraceCodes.length === 0) {
        this.$message.warning('请至少选择一个追溯码进行补传');
        return;
      }
      
      // 检查追溯码数量是否超过1万个
      if (this.selectedTraceCodes.length > 10000) {
        this.$message.warning('追溯码数量不能超过1万个');
        return;
      }
      
      // 检查是否有重复的追溯码
      const uniqueCodes = [...new Set(this.selectedTraceCodes)];
      if (uniqueCodes.length !== this.selectedTraceCodes.length) {
        this.$message.warning('选择的追溯码中存在重复的码，请检查');
        return;
      }
      
      this.transferDialogVisible = false;
      this.retryUploadDialog = true;
      this.retryUploadStep = 0;
      this.retryUploadDetails = [];
      this.retryUploadHasError = false;
      this.showRetryButton = false;
      this.retryUploadSuccess = true;
      this.retryUploadError = '';
      this.retryUploading = false;
      
      // 开始补传流程
      this.startRetryUploadProcess();
    },
    // 开始补传流程
    async startRetryUploadProcess() {
      try {
        const row = this.currentRetryRow;
        
        // 步骤1：检查数据
        await this.checkRetryUploadStep1(row);
        
        // 步骤2：准备补传
        await this.checkRetryUploadStep2(row);
        
        // 步骤3：调用接口
        const uploadResult = await this.checkRetryUploadStep3(row);
        
        // 步骤4：上传结果
        await this.checkRetryUploadStep4(uploadResult, row);
        
        // 步骤5：完成补传
        await this.checkRetryUploadStep5(uploadResult, row);
        
      } catch (error) {
        console.error('补传流程异常:', error);
        this.addRetryUploadDetail('补传流程异常: ' + error.message, 'error');
        this.retryUploadHasError = true;
        this.showRetryButton = true;
      }
    },
    // 步骤1：检查数据
    async checkRetryUploadStep1(row) {
      this.retryUploadStep = 0;
      this.retryUploadSteps[0].description = '正在检查补传数据...';
      this.addRetryUploadDetail('正在检查补传数据...', 'info');
      
      // 检查必要字段
      if (!row.bizNum) {
        throw new Error('业务单据编号不能为空');
      }
      
      if (this.selectedTraceCodes.length === 0) {
        throw new Error('请至少选择一个追溯码进行补传');
      }
      
      this.addRetryUploadDetail('数据检查通过', 'success');
      this.retryUploadSteps[0].description = '数据检查通过';
      
      await new Promise(resolve => setTimeout(resolve, 1000));
    },
    // 步骤2：准备补传
    async checkRetryUploadStep2(row) {
      this.retryUploadStep = 1;
      this.retryUploadSteps[1].description = '正在准备补传参数...';
      this.addRetryUploadDetail('正在准备补传参数...', 'info');
      
      // 准备补传参数
      this.addRetryUploadDetail(`业务类型: ${this.formatBizType(row)}`, 'info');
      this.addRetryUploadDetail(`业务单据编号: ${row.bizNum}`, 'info');
      this.addRetryUploadDetail(`选择补传的追溯码数量: ${this.selectedTraceCodes.length}`, 'info');
      this.addRetryUploadDetail(`选择的追溯码: ${this.selectedTraceCodes.slice(0, 5).join(', ')}${this.selectedTraceCodes.length > 5 ? '...' : ''}`, 'info');
      
      this.addRetryUploadDetail('参数准备完成', 'success');
      this.retryUploadSteps[1].description = '参数准备完成';
      
      await new Promise(resolve => setTimeout(resolve, 1000));
    },
    // 步骤3：调用接口
    async checkRetryUploadStep3(row) {
      this.retryUploadStep = 2;
      this.retryUploadSteps[2].description = '正在调用补传接口...';
      this.addRetryUploadDetail('正在调用补传接口...', 'info');
      
      let uploadResult = { success: false, message: '' };
      
      try {
        // 根据业务类型调用不同的接口
        if (row.bizType === 321) {
          // 调用 msfxUploadRetail 接口
          this.addRetryUploadDetail('调用零售接口 (msfxUploadRetail)', 'info');
          
          const params = {
            billType: row.billType || 0,
            bizNum: row.bizNum || '',
            traceCodes: this.selectedTraceCodes.join(',')  // 使用选中的追溯码
          };
          
          this.addRetryUploadDetail(`接口参数: ${JSON.stringify(params)}`, 'info');
          
          const response = await msfxUploadRetail(params);
          
          if (response.code === 200) {
            uploadResult = { success: true, message: '上传成功', data: response.data };
            this.addRetryUploadDetail('零售接口调用成功', 'success');
            this.retryUploadSteps[2].description = '接口调用成功';
          } else {
            uploadResult = { success: false, message: response.message || '上传失败' };
            this.addRetryUploadDetail(`零售接口调用失败: ${response.message}`, 'error');
            this.retryUploadSteps[2].description = '接口调用失败';
            this.retryUploadError = response.message || '上传失败';
          }
          
        } else if (row.bizType === 102 || row.bizType === 202 || row.bizType === 103 || 
                  row.bizType === 113 || row.bizType === 201 || row.bizType === 217) {
          // 调用 msfxUploadInoutBill 接口
          this.addRetryUploadDetail('调用采购入库/出库接口 (msfxUploadInoutBill)', 'info');
          
          const params = {
            billType: row.billType || 0,
            bizNum: row.bizNum || '',
            fromUserId: row.fromUserId || '',
            physicType: row.physicType || 0,
            toUserId: row.toUserId || '',
            traceCodes: this.selectedTraceCodes.join(',')  // 使用选中的追溯码
          };
          
          this.addRetryUploadDetail(`接口参数: ${JSON.stringify(params)}`, 'info');
          
          const response = await msfxUploadInoutBill(params);
          
          if (response.code === 200) {
            uploadResult = { success: true, message: '上传成功', data: response.data };
            this.addRetryUploadDetail('采购入库/出库接口调用成功', 'success');
            this.retryUploadSteps[2].description = '接口调用成功';
          } else {
            uploadResult = { success: false, message: response.message || '上传失败' };
            this.addRetryUploadDetail(`采购入库/出库接口调用失败: ${response.message}`, 'error');
            this.retryUploadSteps[2].description = '接口调用失败';
            this.retryUploadError = response.message || '上传失败';
          }
          
        } else {
          // 默认调用 msfxUploadInoutBill 接口
          this.addRetryUploadDetail('调用默认接口 (msfxUploadInoutBill)', 'info');
          
          const params = {
            billType: row.billType || 0,
            bizNum: row.bizNum || '',
            fromUserId: row.fromUserId || '',
            physicType: row.physicType || 0,
            toUserId: row.toUserId || '',
            traceCodes: this.selectedTraceCodes.join(',')  // 使用选中的追溯码
          };
          
          this.addRetryUploadDetail(`接口参数: ${JSON.stringify(params)}`, 'info');
          
          const response = await msfxUploadInoutBill(params);
          
          if (response.code === 200) {
            uploadResult = { success: true, message: '上传成功', data: response.data };
            this.addRetryUploadDetail('默认接口调用成功', 'success');
            this.retryUploadSteps[2].description = '接口调用成功';
          } else {
            uploadResult = { success: false, message: response.message || '上传失败' };
            this.addRetryUploadDetail(`默认接口调用失败: ${response.message}`, 'error');
            this.retryUploadSteps[2].description = '接口调用失败';
            this.retryUploadError = response.message || '上传失败';
          }
        }
        
        return uploadResult;
        
      } catch (error) {
        console.error('调用接口失败:', error);
        this.addRetryUploadDetail('调用接口失败: ' + error.message, 'error');
        this.retryUploadSteps[2].description = '接口调用异常';
        this.retryUploadError = error.message;
        throw error;
      }
    },
    // 步骤4：上传结果
    async checkRetryUploadStep4(uploadResult, row) {
      this.retryUploadStep = 3;
      this.retryUploadSteps[3].description = '正在处理上传结果...';
      this.addRetryUploadDetail('正在处理上传结果...', 'info');
      
      if (uploadResult.success) {
        this.addRetryUploadDetail('上传结果处理成功', 'success');
        this.retryUploadSteps[3].description = '上传结果处理成功';
        this.retryUploadSuccess = true;
      } else {
        this.addRetryUploadDetail(`上传结果处理失败: ${uploadResult.message}`, 'error');
        this.retryUploadSteps[3].description = '上传结果处理失败';
        this.retryUploadSuccess = false;
        this.retryUploadHasError = true;
      }
      
      await new Promise(resolve => setTimeout(resolve, 1000));
    },
    // 步骤5：完成补传
    async checkRetryUploadStep5(uploadResult, row) {
      this.retryUploadStep = 4;
      this.retryUploadSteps[4].description = '补传完成';
      
      if (uploadResult.success) {
        this.addRetryUploadDetail('补传完成', 'success');
        
        // 刷新数据
        this.fetchData();
        
        // 1秒后自动关闭模态框
        this.autoCloseTimer = setTimeout(() => {
          this.closeRetryUploadDialog();
          this.$message.success('补传成功');
        }, 1000);
      } else {
        this.addRetryUploadDetail('补传失败', 'error');
        this.showRetryButton = true;
      }
    },
    // 获取步骤状态
    getStepStatus(index) {
      if (this.retryUploadHasError && index === this.retryUploadStep) {
        return 'error';
      }
      if (index < this.retryUploadStep) {
        return 'finish';
      } else if (index === this.retryUploadStep) {
        return 'process';
      } else {
        return 'wait';
      }
    },
    // 获取详情图标
    getDetailIcon(type) {
      switch (type) {
        case 'success': return 'el-icon-success';
        case 'error': return 'el-icon-error';
        case 'warning': return 'el-icon-warning';
        case 'info': 
        default: return 'el-icon-info';
      }
    },
    // 添加补传步骤详情
    addRetryUploadDetail(message, type = 'info') {
      const now = new Date();
      const time = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
      
      this.retryUploadDetails.push({
        message,
        type,
        time
      });
      
      // 滚动到最新消息
      this.$nextTick(() => {
        const container = this.$refs.uploadDetailsContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    // 处理上传取消
    handleRetryUploadCancel() {
      this.$confirm('确定要取消补传吗？取消后需要重新开始。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.retryUploadDialog = false;
        this.resetRetryUpload();
      });
    },
    // 关闭补传对话框
    closeRetryUploadDialog() {
      this.retryUploadDialog = false;
      this.resetRetryUpload();
    },
    // 重置补传状态
    resetRetryUpload() {
      this.retryUploadStep = 0;
      this.retryUploadSteps = [
        { title: '检查数据', description: '正在检查补传数据...' },
        { title: '准备补传', description: '正在准备补传参数...' },
        { title: '调用接口', description: '正在调用补传接口...' },
        { title: '上传结果', description: '正在处理上传结果...' },
        { title: '完成补传', description: '补传完成。' }
      ];
      this.retryUploadDetails = [];
      this.retryUploadHasError = false;
      this.showRetryButton = false;
      this.retryUploadSuccess = true;
      this.retryUploadError = '';
      this.retryUploading = false;
      this.currentRetryRow = null;
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      }
    },
    // 分页大小改变事件
    handleSizeChange(size) {
      this.queryParams.pageSize = size;
      this.fetchData();
    },
    // 当前页改变事件
    handleCurrentChange(page) {
      this.queryParams.pageNum = page;
      this.fetchData();
    }
  }
};
</script>

<style lang="less" scoped>
/* 整体容器样式 */
.el-container {
  height: calc(100vh - 120px);
  overflow: hidden;
}

/* 左侧树形菜单样式 */
.el-aside {
  background-color: #f5f7fa;
  border-right: 1px solid #e6e6e6;
  overflow-y: auto;
  
  .logo-container {
    display: flex;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #e6e6e6;
    
    .logo {
      width: 36px;
      height: 36px;
      background-color: #409EFF;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      
      i {
        color: white;
        font-size: 20px;
      }
    }
    
    .system-name {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
  }
  
  .el-tree {
    padding: 10px;
    
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      font-size: 12px;
      
      i {
        margin-right: 5px;
        color: #409EFF;
      }
    }
  }
}

/* 右侧主内容区域样式 */
.el-container {
  height: 100%;
}

/* 顶部标题栏样式 */
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;
  
  .page-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  
  .filter-section {
    display: flex;
    align-items: center;
    
    .filter-item {
      margin-right: 15px;
      
      .filter-label {
        font-size: 14px;
        color: #666;
        margin-right: 5px;
      }
    }
  }
}

/* 表格区域样式 */
.el-main {
  overflow-y: auto;
  
  .pagination-container {
    margin-top: 15px;
    text-align: right;
  }
  
  .action-buttons {
    margin-top: 8px;
    text-align: left;
  }
}

/* 穿梭框模态框样式 */
.trace-code-transfer-dialog {
  .custom-dialog-header {
    background: linear-gradient(135deg, #ebfaff 0%, #00557f 100%);
    padding: 20px 20px 15px 20px;
    margin: -20px -20px 0 -20px;
    border-radius: 4px 4px 0 0;
    
    .dialog-title-text {
      font-size: 18px;
      font-weight: bold;
      color: white;
    }
  }
  
  .transfer-dialog-content {
    .error-trace-code {
      color: #f56c6c;
      font-weight: bold;
    }
    
    .error-details {
      margin-top: 20px;
      padding: 10px;
      background-color: #fef0f0;
      border-radius: 4px;
      border: 1px solid #fde2e2;
      
      .error-title {
        font-weight: bold;
        margin-bottom: 10px;
        color: #f56c6c;
      }
      
      .error-codes {
        display: flex;
        flex-wrap: wrap;
      }
    }
    
    .trace-code-item {
      font-size: 12px;
      word-break: break-all;
      overflow-wrap: break-word;
      white-space: normal;
    }
  }
  
  /* 设置穿梭框的宽度和字体大小 */
  /deep/ .el-transfer-panel {
    width: 300px;
    
    .el-checkbox__label {
      font-size: 12px;
    }
    
    .el-transfer-panel__list {
      height: 350px;
    }
    
    .el-transfer-panel__item {
      height: auto;
      min-height: 32px;
      padding: 8px 10px;
      word-break: break-all;
      overflow-wrap: break-word;
      white-space: normal;
      line-height: 1.4;
    }
  }
  
  /deep/ .el-transfer {
    display: flex;
    justify-content: space-between;
  }
}

/* 步骤进度条样式 */
.upload-progress-dialog {
  .upload-steps {
    margin-bottom: 20px;
  }
  
  .upload-details {
    margin-top: 20px;
    
    .details-title {
      font-weight: bold;
      margin-bottom: 10px;
    }
    
    .details-content {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      padding: 10px;
      
      .detail-item {
        padding: 5px 0;
        display: flex;
        align-items: center;
        
        i {
          margin-right: 8px;
        }
        
        &.success {
          color: #67C23A;
        }
        
        &.error {
          color: #F56C6C;
        }
        
        &.warning {
          color: #E6A23C;
        }
        
        &.info {
          color: #909399;
        }
        
        .detail-time {
          margin-left: auto;
          color: #909399;
          font-size: 12px;
        }
      }
    }
  }
  
  .upload-progress {
    margin-top: 20px;
  }
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>